import { createAction, props } from '@ngrx/store';

export const addProductsManually = createAction(
  '[Product List] Add products manually',
  props<{ listId: string }>(),
);
